import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from 'styled-components';
import SkipCheckbox from '../Components/SkipCheckbox';
import { categoryTypeQuestion } from 'constants/questionTypes';
import {words} from '../translations'




const Categories = (props) => {

  const { saveUpdatedAnswers,
    currentQuestionDet,
    question,
    description,
    categoryQues,
    organizationName,
    language,
    custom_thanks,
    custom_title,
    public_intro,
    custom_category_intro,
    customHeader,
  } = props

  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCategoryQues, setSelectedCategoryQues] = useState(false);
  const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
  const [isNA, setNA] = useState(false);
  const [isOpenEnded, setIsOpenEnded] = useState(false);
  const [openEndedText, setOpenEndedText] = useState('');
  const [activeGroup, setActiveGroup] = useState(null);

  useEffect(() => {
    if (categoryQues) {
      const CatQues = categoryQues.filter(cq =>
        cq.id === currentQuestionDet.category_question_id)?.[0]
      setSelectedCategoryQues(CatQues)
      if (CatQues?.answers) {
        setSelectedCategoryOptions(CatQues?.answers)
      } else {
      setSelectedCategoryOptions(false)
    }
    } 
  }, [categoryQues, currentQuestionDet])

  useEffect(() => {
    if (currentQuestionDet?.response) {
      if (currentQuestionDet?.response?.response === 'N/A') {
        setNA(true)
        setSelectedCategory('')
        setIsOpenEnded(false)
        setOpenEndedText('')
      } else if (currentQuestionDet?.response?.response === 'open_ended') {
        setNA(false)
        setSelectedCategory('')
        setIsOpenEnded(true)
        setOpenEndedText(currentQuestionDet?.response?.open_ended_text || '')
      } else if (selectedCategoryQues?.answers) {
        setSelectedCategory(
          selectedCategoryQues?.answers.filter(
            op => op.id === currentQuestionDet?.response.response
          )?.[0]
        )
        setNA(false)
        setIsOpenEnded(false)
        setOpenEndedText('')
      } else {
        setSelectedCategory('')
        setNA(false)
        setIsOpenEnded(false)
        setOpenEndedText('')
      }
    } else {
      setSelectedCategory('')
      setNA(false)
      setIsOpenEnded(false)
      setOpenEndedText('')
    }
  },[currentQuestionDet, selectedCategoryQues])

  function SaveResponse(response) {
    const Response = {
      ques_sort_order: currentQuestionDet?.id,
      id: selectedCategoryQues.id,
      response: response?.id, 
      subfactor: selectedCategoryQues?.subfactor,
      priority: selectedCategoryQues?.priority,
      role: selectedCategoryQues?.role,
      reverse: selectedCategoryQues?.reverse,
      clicked: true,
    }
    saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    setSelectedCategory(selectedCategoryQues?.answers.find(op => op.id === Response.response))
  }

  function SaveOpenEndedResponse(text) {
    if (text.trim().length > 0) {
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues.id,
        response: 'open_ended',
        open_ended_text: text,
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: true,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    } else {
      // When clearing text, keep open-ended selected but disable Next
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues.id,
        response: 'open_ended',
        open_ended_text: '',
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: false,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    }
    setOpenEndedText(text)
  }

  const handleNAClick = () => {
    if (!isNA) {
      setNA(true)
      setSelectedCategory('')
      setIsOpenEnded(false)
      setOpenEndedText('')
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues?.id,
        response: 'N/A',
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: true,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    } else {
      setNA(false)
      setSelectedCategory('')
      setIsOpenEnded(false)
      setOpenEndedText('')
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues?.id,
        response: null,
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: false,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    }
  }

  const handleOpenEndedClick = () => {
    setIsOpenEnded(true)
    setNA(false)
    setSelectedCategory('')
    // Save a pending open-ended response to ensure Next is disabled until text is entered
    const Response = {
      ques_sort_order: currentQuestionDet?.id,
      id: selectedCategoryQues?.id,
      response: 'open_ended',
      open_ended_text: '',
      subfactor: selectedCategoryQues?.subfactor,
      priority: selectedCategoryQues?.priority,
      role: selectedCategoryQues?.role,
      reverse: selectedCategoryQues?.reverse,
      clicked: false,
    }
    saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
  }

  const getOptionName = (option) => {
    if (!option) return ''
    if (language === 'FR' && option?.fr) return option.fr
    if (language === 'ES' && option?.es) return option.es
    return option.name
  }

  const getOpenEndedName = () => {
    return language === 'FR' ? selectedCategoryQues?.open_ended_name_fr : selectedCategoryQues?.open_ended_name
  }

  const groupKeys = useMemo(() => {
    const titles = selectedCategoryQues?.group_titles
    if (!titles) return []
    return Object.keys(titles)
  }, [selectedCategoryQues])

  const getGroupTitle = (groupKey) => {
    const titles = selectedCategoryQues?.group_titles
    if (!titles) return groupKey
    const localized = titles?.[groupKey]
    return localized?.[language] || localized?.EN || groupKey
  }

  const optionsByGroup = useMemo(() => {
    if (!groupKeys.length) return {}
    const map = {}
    groupKeys.forEach(k => { map[k] = [] })
    if (selectedCategoryOptions?.length) {
      selectedCategoryOptions.forEach(opt => {
        if (opt?.group && map.hasOwnProperty(opt.group)) {
          map[opt.group].push(opt)
        }
      })
    }
    return map
  }, [groupKeys, selectedCategoryOptions])

  const ungroupedOptions = useMemo(() => {
    if (!selectedCategoryOptions?.length) return []
    return selectedCategoryOptions.filter(opt => !opt?.group)
  }, [selectedCategoryOptions])

  const isSelectedOption = (option) => {
    if (!option || isOpenEnded) return false
    return selectedCategory?.id === option?.id
  }

  const handleOptionClick = (option) => {
    setNA(false)
    setIsOpenEnded(false)
    setOpenEndedText('')
    SaveResponse(option)
  }

  const OptionsScroller = ({ children, hintText }) => {
    const containerRef = useRef(null)
    const sentinelRef = useRef(null)
    const [showHint, setShowHint] = useState(false)

    useEffect(() => {
      const sentinel = sentinelRef.current
      if (!sentinel) return
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0]
        // Show hint when the bottom sentinel is NOT visible in viewport
        setShowHint(!entry.isIntersecting)
      }, { root: null, threshold: 0.01 })
      observer.observe(sentinel)
      return () => observer.disconnect()
    }, [children])

    return (
      <ScrollerContainer ref={containerRef}>
        {children}
        <Sentinel ref={sentinelRef} />
        <MoreHint visible={showHint}>
          <span>{words?.more_options?.[language] || hintText || 'More options'}</span>
          <DownChevron />
        </MoreHint>
      </ScrollerContainer>
    )
  }

  const getTitle = ()=>{
    // For the injected category intro, prefer the new localized title with fallback to existing text
    if(currentQuestionDet?.from === 'category_intro'){
      const titleObj = custom_category_intro?.title;
      if(titleObj && typeof titleObj === 'object'){
        const localized = titleObj?.[language];
        if(typeof localized === 'string' && localized.trim().length > 0){
          return localized;
        }
      }
      if(language === 'FR'){
        return custom_category_intro?.fr;
      }
      return custom_category_intro?.text;
    }

    if(selectedCategoryQues?.fr_name && language === 'FR'){
      return selectedCategoryQues?.fr_name
    }

    if(selectedCategoryQues?.es_name && language === 'ES'){
      return selectedCategoryQues?.es_name
    }

    if(selectedCategoryQues?.por && language === 'POR'){
      return selectedCategoryQues?.por
    }

    if(selectedCategoryQues?.name){
      return selectedCategoryQues?.name
    }

    return words["category_completed"][language]
  }

  const getDescription = () =>{
    // Render custom category intro if this is the inserted intro screen
    if(currentQuestionDet?.from === 'category_intro'){
      if(language === 'FR'){
        return custom_category_intro?.fr
      }
      return custom_category_intro?.text
    }

    if(selectedCategoryQues?.fr && language === 'FR'){
      return selectedCategoryQues?.fr
    }
    if(selectedCategoryQues?.fr_question && language === 'FR'){
      return selectedCategoryQues?.fr_question
    }
    if(selectedCategoryQues?.es && language === 'ES'){
      return selectedCategoryQues?.es
    }
    if(selectedCategoryQues?.por && language === 'POR'){
      return selectedCategoryQues?.por
    }
    if(selectedCategoryQues?.question){
      return selectedCategoryQues?.question
    }

    if(public_intro =='hockey_participants'){
      return language === 'EN' ? EN1 : FR1

    }
    if(custom_thanks){
      if(language === 'FR'){
        return custom_thanks?.fr
      }

      return custom_thanks?.text
    }
    return words["category_completed2"][language].replace('{organizationName}',organizationName)
  }

  const renderInlineBold = (text) => {
    const parts = String(text).split(/(\*\*[^*]+?\*\*)/g)
    return parts.map((part, idx) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={idx}>{part.slice(2, -2)}</strong>
      }
      return part
    })
  }

  const renderMarkdownLite = (content) => {
    if (!content) return null
    if (React.isValidElement(content)) return content

    const normalized = String(content)
      .replace(/\r\n|\r/g, '\n')
      .replace(/\\n/g, '\n')

    const paragraphs = normalized.split(/\n{2,}/)
    return paragraphs.map((para, pIdx) => {
      const lines = para.split(/\n/)
      return (
        <p key={pIdx}>
          {lines.map((line, lIdx) => (
            <React.Fragment key={lIdx}>
              {renderInlineBold(line)}
              {lIdx < lines.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </p>
      )
    })
  }

  const getCustomTitle = () =>{
    if(custom_title?.EN){
      return custom_title[language]
    }
    return words['category'][language]
  }


  return (
    <CategoriesContainer>
      {currentQuestionDet?.from !== 'category_intro' && (
        customHeader?.useImageAsQualifier && customHeader?.imageUrl ? (
          <HeaderImage
            src={customHeader.imageUrl}
            alt=""
            $height={customHeader.imageHeight}
          />
        ) : (
          <Title>{getCustomTitle()}</Title>
        )
      )}
      <QuestionText>{getTitle()}</QuestionText>
      <Description questionLength={selectedCategoryQues?.question?.length} >{renderMarkdownLite(getDescription())}</Description>
      {selectedCategoryOptions && (
        <ListWrapper>
          {!!groupKeys.length && groupKeys.map((g) => (
            <GroupSection key={`grp_${g}`}>
              <GroupHeader
                role="button"
                tabIndex={0}
                onClick={() => setActiveGroup(prev => prev === g ? null : g)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveGroup(prev => prev === g ? null : g) } }}
                aria-expanded={activeGroup === g}
              >
                <span>{getGroupTitle(g)}</span>
                <GroupChevron open={activeGroup === g} />
              </GroupHeader>
              <GroupContent open={activeGroup === g}>
                <OptionsScroller>
                  <OptionsList>
                    {(optionsByGroup[g] || []).map((option) => (
                      <OptionItem
                        key={`opt_${g}_${option?.id || option?.name}`}
                        role="button"
                        tabIndex={0}
                        aria-pressed={isSelectedOption(option)}
                        selected={isSelectedOption(option)}
                        onClick={() => handleOptionClick(option)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOptionClick(option) } }}
                      >
                        {getOptionName(option)}
                      </OptionItem>
                    ))}
                  </OptionsList>
                </OptionsScroller>
              </GroupContent>
            </GroupSection>
          ))}

          {!!ungroupedOptions.length && (
            <OptionsScroller>
              <OptionsList>
                {ungroupedOptions.map((option) => (
                  <OptionItem
                    key={`flat_${option?.id || option?.name}`}
                    role="button"
                    tabIndex={0}
                    aria-pressed={isSelectedOption(option)}
                    selected={isSelectedOption(option)}
                    onClick={() => handleOptionClick(option)}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOptionClick(option) } }}
                  >
                    {getOptionName(option)}
                  </OptionItem>
                ))}
              </OptionsList>
            </OptionsScroller>
          )}

          {!groupKeys.length && !ungroupedOptions.length && (
            <OptionsScroller>
              <OptionsList>
                {(selectedCategoryOptions || []).map((option) => (
                  <OptionItem
                    key={`all_${option?.id || option?.name}`}
                    role="button"
                    tabIndex={0}
                    aria-pressed={isSelectedOption(option)}
                    selected={isSelectedOption(option)}
                    onClick={() => handleOptionClick(option)}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOptionClick(option) } }}
                  >
                    {getOptionName(option)}
                  </OptionItem>
                ))}
              </OptionsList>
            </OptionsScroller>
          )}

          {selectedCategoryQues?.allow_open_ended && (
            <OptionItem
              key="open_ended"
              role="button"
              tabIndex={0}
              aria-pressed={isOpenEnded}
              selected={isOpenEnded}
              onClick={handleOpenEndedClick}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpenEndedClick() } }}
            >
              {getOpenEndedName()}
            </OptionItem>
          )}
        </ListWrapper>
      )}

      <AnimatedTextInputContainer isVisible={isOpenEnded}>
        <TextInput
          value={openEndedText}
          onChange={(e) => SaveOpenEndedResponse(e.target.value)}
          placeholder={language === 'FR' ? selectedCategoryQues?.open_ended_name_fr : selectedCategoryQues?.open_ended_name}
          maxLength={50}
        />
      </AnimatedTextInputContainer>

      {(selectedCategoryQues?.allow_skip || question?.allowSkip) && (
        <SkipCheckbox
          id={`skip_${currentQuestionDet?.id}`}
          selected={isNA}
          onClick={handleNAClick}
          language={language}
        />
      )}

    </CategoriesContainer>
  );
};

export default Categories;

const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width:calc(100%);
  max-width:600px;
  padding-bottom:150px;
  padding-top:20px;
`;

const HeaderImage = styled.img`
  display: block;
  max-width: 100%;
  height: ${props => (props.$height ? `${props.$height}px` : "auto")};
  margin-bottom: 16px;
`;

const QuestionText = styled.h2`
  margin-bottom: 1rem;
  color:#2A3039;
  font-size: 20px;
  font-weight: 600;
`;

const Title = styled.div`
color: #2D70E2;
text-transform: uppercase;
font-size:14px;
font-weight:600;
`

const Description = styled.div`
color: #2A3039;
font-family: 'Raleway';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height:1.6;
margin-bottom:26px;

@media(max-height:700px){
  font-size:${props => props.questionLength > 200 ? '14px' : '16px'};
}

@media(max-height:550px){
  font-size:${props => props.questionLength > 200 ? '12px' : '16px'};
}
`

const AnimatedTextInputContainer = styled.div`
  max-height: ${props => props.isVisible ? '50px' : '0'};
  opacity: ${props => props.isVisible ? '1' : '0'};
  overflow: visible;
  transition: all 0.3s ease-in-out;
  margin-bottom: ${props => props.isVisible ? '16px' : '0'};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(-10px)'};
`

const TextInput = styled.input`
  width: 100%;
  max-width: 600px;
  padding: 12px 16px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  outline: none;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  background-color: #F9FAFB;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;

  &:focus {
    border-color: #3B82F6;
    background-color: #FFFFFF;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &:hover {
    border-color: #D1D5DB;
    background-color: #FFFFFF;
  }

  &::placeholder {
    color: #9CA3AF;
    font-style: italic;
  }
`

const ListWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
`

const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
`

const OptionItem = styled.div`
  padding: 12px 14px;
  border: 1px solid ${props => props.selected ? '#3B82F6' : '#E5E7EB'};
  background: ${props => props.selected ? 'rgba(59, 130, 246, 0.08)' : '#FFFFFF'};
  color: #2A3039;
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  outline: none;

  &:hover {
    background: ${props => props.selected ? 'rgba(59, 130, 246, 0.12)' : '#F9FAFB'};
    border-color: ${props => props.selected ? '#3B82F6' : '#D1D5DB'};
  }

  &:focus {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }

  @media (max-width: 480px) {
    padding: 14px 16px;
    font-size: 15px;
  }
`

const GroupSection = styled.div`
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
`

const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: #FFFFFF;
  cursor: pointer;
  user-select: none;
  color: #2A3039;
  font-weight: 600;
  font-size: 14px;
  outline: none;

  &:hover { background: #F9FAFB; }
  &:focus { box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15); }
`

const GroupChevron = styled.i`
  border: solid #666D79;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: ${({ open }) => (open ? 'rotate(-135deg)' : 'rotate(45deg)')};
`

const GroupContent = styled.div`
  max-height: ${({ open }) => (open ? '1500px' : '0')};
  opacity: ${({ open }) => (open ? 1 : 0)};
  transition: max-height 0.28s ease, opacity 0.22s ease;
  will-change: max-height, opacity;
  overflow: hidden;
`

// Scroll viewport without visible scrollbar + hint overlay
const ScrollerContainer = styled.div`
  position: relative;
`

const MoreHint = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
  background: linear-gradient(to top, rgba(255,255,255,0.96), rgba(255,255,255,0));
  color: #6B7280; /* gray-500 */
  font-size: 12px;
  font-weight: 600;
  pointer-events: none;
  opacity: ${props => props.visible ? 1 : 0};
  transform: translateY(${props => props.visible ? '0' : '8px'});
  transition: opacity 0.2s ease, transform 0.2s ease;
`

const DownChevron = styled.i`
  border: solid #9CA3AF; /* gray-400 */
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
`

const Sentinel = styled.div`
  width: 1px;
  height: 1px;
`

 

const EN1 = (<div>
  <p>
  For the remainder of the survey, we will be asking about your personal experience with the environment and culture of hockey in Canada. However, to ensure your feedback reflects the current state of hockey, please focus only on your experiences from the <strong>past five years</strong>.
  </p>
  <p>
  As you answer, think about your recent hockey participation and how it has shaped your experience. Your honest responses will help us understand the opportunities for achieving healthy culture in the future of hockey.
  </p>
</div>)

const FR1 = (<div>
  <p>
  Pour le reste du sondage, nous vous demanderons de partager votre expérience personnelle de l'environnement et de la culture du hockey au Canada. Cependant, pour garantir que vos commentaires reflètent l'état actuel du hockey, veuillez vous concentrer uniquement sur vos expériences des <strong>cinq dernières années</strong>.
  </p>
  <p>
  En répondant, réfléchissez à votre participation récente au hockey et à la manière dont elle a façonné votre expérience. Vos réponses honnêtes nous aideront à comprendre les opportunités pour atteindre une culture saine dans l'avenir du hockey.
  </p>
</div>
)